import { FeatureIdEnum } from '../../enums';

import { AppRouteConfig } from '../../models';

import { CatalogForm, InstancesForm, InstancesList, KpisForm, PermissionsForm, ToolsForm } from '../../views';

import { ROUTER_CONSTS } from '../router.consts';
import { ENABLED_FILTER_CONFIG } from '../routes.filters';
import { ROUTES_PATHS } from '../routes.paths';

const INSTANCES_PATHS = Object.assign(ROUTES_PATHS, {
  instances: 'instances',
  permissions: 'permissions',
  kpis: 'kpis',
  catalog: 'catalog',
  tools: 'tools'
});

const PERMISSIONS_ROUTE = {
  path: INSTANCES_PATHS.permissions,
  component: PermissionsForm,
  meta: {
    featureId: FeatureIdEnum.PERMISSIONS,
    parentRouteName: ROUTER_CONSTS.routes.instances.list
  }
};

const KPIS_ROUTE = {
  path: INSTANCES_PATHS.kpis,
  component: KpisForm,
  meta: {
    featureId: FeatureIdEnum.KPIS,
    parentRouteName: ROUTER_CONSTS.routes.instances.list
  }
};

const CATALOG_ROUTE = {
  path: INSTANCES_PATHS.catalog,
  component: CatalogForm,
  meta: {
    featureId: FeatureIdEnum.CATALOG,
    parentRouteName: ROUTER_CONSTS.routes.instances.list
  }
};

const TOOLS_ROUTE = {
  path: INSTANCES_PATHS.tools,
  component: ToolsForm,
  meta: {
    featureId: FeatureIdEnum.TOOLS,
    parentRouteName: ROUTER_CONSTS.routes.instances.list
  }
};

const CREATE_INSTANCE_TITLE_I18N_KEY = 'createInstance';
const UPDATE_INSTANCE_TITLE_I18N_KEY = 'updateInstance';

export const INSTANCES_ROUTES: AppRouteConfig[] = [
  {
    name: ROUTER_CONSTS.routes.instances.list,
    path: INSTANCES_PATHS.instances,
    component: InstancesList,
    meta: {
      featureId: FeatureIdEnum.INSTANCE,
      filters: () => ({
        extra: {
          [ENABLED_FILTER_CONFIG.id]: ENABLED_FILTER_CONFIG
        }
      }),
      style: {
        removeContentPadding: true
      }
    }
  }, {
    name: ROUTER_CONSTS.routes.instances.create.root,
    path: `${ INSTANCES_PATHS.instances }/${ INSTANCES_PATHS.actions.create }`,
    component: InstancesForm,
    meta: {
      featureId: FeatureIdEnum.INSTANCE,
      titleI18nKey: CREATE_INSTANCE_TITLE_I18N_KEY,
      parentRouteName: ROUTER_CONSTS.routes.instances.list
    },
    children: [
      {
        ...PERMISSIONS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.create[FeatureIdEnum.PERMISSIONS],
        meta: {
          ...PERMISSIONS_ROUTE.meta,
          titleI18nKey: CREATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...KPIS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.create[FeatureIdEnum.KPIS],
        meta: {
          ...KPIS_ROUTE.meta,
          titleI18nKey: CREATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...CATALOG_ROUTE,
        name: ROUTER_CONSTS.routes.instances.create[FeatureIdEnum.CATALOG],
        meta: {
          ...CATALOG_ROUTE.meta,
          titleI18nKey: CREATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...TOOLS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.create[FeatureIdEnum.TOOLS],
        meta: {
          ...TOOLS_ROUTE.meta,
          titleI18nKey: CREATE_INSTANCE_TITLE_I18N_KEY
        }
      }
    ]
  }, {
    name: ROUTER_CONSTS.routes.instances.update.root,
    path: `${ INSTANCES_PATHS.instances }/${ INSTANCES_PATHS.actions.update }`,
    component: InstancesForm,
    meta: {
      featureId: FeatureIdEnum.INSTANCE,
      titleI18nKey: UPDATE_INSTANCE_TITLE_I18N_KEY,
      parentRouteName: ROUTER_CONSTS.routes.instances.list
    },
    children: [
      {
        ...PERMISSIONS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.update[FeatureIdEnum.PERMISSIONS],
        meta: {
          ...PERMISSIONS_ROUTE.meta,
          titleI18nKey: UPDATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...KPIS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.update[FeatureIdEnum.KPIS],
        meta: {
          ...KPIS_ROUTE.meta,
          titleI18nKey: UPDATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...CATALOG_ROUTE,
        name: ROUTER_CONSTS.routes.instances.update[FeatureIdEnum.CATALOG],
        meta: {
          ...CATALOG_ROUTE.meta,
          titleI18nKey: UPDATE_INSTANCE_TITLE_I18N_KEY
        }
      },
      {
        ...TOOLS_ROUTE,
        name: ROUTER_CONSTS.routes.instances.update[FeatureIdEnum.TOOLS],
        meta: {
          ...TOOLS_ROUTE.meta,
          titleI18nKey: UPDATE_INSTANCE_TITLE_I18N_KEY
        }
      }
    ]
  }
];
